import { useEffect } from 'react';
import { useCreditCardFormContext } from './useCreditCardFormContext';
import { usePaymentContext } from '../../../../../parking/ui/booking-steps/payment/PaymentContext';

export function useDetectTypeByCreditCardNumber() {
	const { watch, setValue } = useCreditCardFormContext();
	const { newCardType } = usePaymentContext();
	const creditCardType = watch('creditCardType');

	useEffect(() => {
		if (newCardType && creditCardType !== newCardType) {
			setValue('creditCardType', newCardType);
		}
	}, [creditCardType, setValue, newCardType]);
}
